module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col row mt-md-3 mt-lg-0 contact-info"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('img', {
    staticClass: "rounded-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": ("/static/assets/imgs/" + _vm.imageName),
      "alt": _vm.altText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col ml-3 ml-lg-0 pl-0"
  }, [_c('div', {
    staticClass: "row mb-1"
  }, [_c('div', {
    staticClass: "col-1 pl-0 pr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col pl-0 consultant-name"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-nowrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col pl-0 text-nowrap contact-phone"
  }, [_vm._v("\n        " + _vm._s(_vm.contactType) + ":\n        "), _c('a', {
    staticClass: "consultant-phone_number",
    attrs: {
      "href": _vm.phoneURl
    }
  }, [_vm._v(_vm._s(_vm.phoneNumber))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-1 pl-0 pr-2 d-flex align-items-center justify-content-end"
  }, [_c('span', {
    staticClass: "phone-icon fa fa-phone"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db21107a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/ContactInfo.vue
// module id = 2010
// module chunks = 5